/**
 * Smooth scroll to #product-bundle when the link targets the current page (no full reload).
 * Full URL + hash from another page still navigates normally; we smooth-scroll after load.
 */
(function () {
  const BUNDLE_HASH = '#product-bundle';

  function bundleEl() {
    return document.getElementById('product-bundle');
  }

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function scrollToBundle() {
    const el = bundleEl();
    if (!el) return;
    el.scrollIntoView({
      behavior: prefersReducedMotion() ? 'auto' : 'smooth',
      block: 'start',
    });
  }

  function pathsMatch(a, b) {
    if (a === b) return true;
    const na = a.replace(/\/$/, '') || '/';
    const nb = b.replace(/\/$/, '') || '/';
    return na === nb;
  }

  function isSamePageBundleLink(href) {
    if (!href || !bundleEl()) return false;
    if (!href.includes('product-bundle')) return false;

    let url;
    try {
      url = new URL(href.trim(), window.location.href);
    } catch {
      return false;
    }

    if (url.hash !== BUNDLE_HASH) return false;

    return pathsMatch(url.pathname, window.location.pathname);
  }

  document.addEventListener(
    'click',
    function (e) {
      const a = e.target.closest('a[href*="#product-bundle"]');
      if (!a) return;
      if (!isSamePageBundleLink(a.getAttribute('href'))) return;

      e.preventDefault();
      scrollToBundle();

      if (history.replaceState) {
        const next = new URL(window.location.href);
        next.hash = 'product-bundle';
        history.replaceState(null, '', next.pathname + next.search + BUNDLE_HASH);
      }
    },
    true
  );

  function onLoadHash() {
    if (window.location.hash !== BUNDLE_HASH) return;
    if (!bundleEl()) return;
    requestAnimationFrame(scrollToBundle);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onLoadHash);
  } else {
    onLoadHash();
  }
})();
